import React, { useState, useRef, useEffect } from 'react'
import "./contact.css";
import { Overlay, Tooltip } from "react-bootstrap";
import axiosConfig from "../../Service/AxiosConfig";

const Contact = () => {

    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        comments: ""
    });
    const [errors, setErrors] = useState("");
    const [message, setMessage] = useState("");
    const handleChange = (e) => {
        if (e.target.name === "mobile") {
            const val = e.target.value.replace(/\D/g, ""); // keep only digits
            setFormData({ ...formData, [e.target.name]: val });
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };

    useEffect(() => {
        if (message || errors) {
            const timer = setTimeout(() => {
                setMessage("");
                setErrors("");
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [message, errors]);

    function handleSubmit(e) {
        e.preventDefault();
        setErrors("");
        setMessage("");
        console.log("Form Submitted:", formData);
        const FormDataToSend = new FormData();
        FormDataToSend.append("first_name", formData.first_name);
        FormDataToSend.append("last_name", formData.last_name);
        FormDataToSend.append("email", formData.email);
        FormDataToSend.append("mobile", formData.mobile);
        FormDataToSend.append("comments", formData.comments);
        axiosConfig
            .post("blogapp/contacts/", FormDataToSend)
            .then((res) => {
                setMessage("Form Submitted Successfully!");
                setFormData({
                    first_name: "",
                    last_name: "",
                    email: "",
                    mobile: "",
                    comments: ""
                });
            })
            .catch((err) => {
                console.log(err, "error");
                let error = err?.response?.data?.error;
                setErrors(error);
            });
    }
    const [hoveredInput, setHoveredInput] = useState(null);
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const emailRef = useRef(null);
    const numberRef = useRef(null);
    const queryRef = useRef(null);

    return (
        <>
            <div className='banner'>Contact Us</div>
            <div className="container mt-4">
                <div className="row">
                    <div className="col-md-6 text-start">
                        <div className="col-md-8 ">
                            <h2>Our Address</h2>
                            <span className='contact-info'>8-50/11, Dammaiguda Rd, near ECIL,
                                Narayana Puri Colony, Sai Priya Colony,
                                Sainikpuri, Secunderabad, Telangana 500083</span>
                            <div>
                                <h4 className='text banner-color mt-4 contact-info'>Mobile no:</h4>
                                <span className='contact-info' onClick={() => {
                                    navigator.clipboard.writeText('+91 099665 00800');
                                    // alert('Phone number copied!');
                                }}
                                    style={{ cursor: 'pointer', color: 'black', textDecoration: 'none' }}
                                >+91 099665 00800</span>
                            </div>
                            <div>
                                <h4 className='text banner-color mt-4 contact-info'>Email:</h4>
                                <span className='contact-info mb-10 '>info@shriadithya.com</span>
                            </div>
                        </div>
                        <hr style={{ opacity: "0.001" }} />
                        {/* for showing gap on mobile device */}

                    </div>

                    <div className="row col-md-6 text-start">
                        <h2>Request a <span className='text banner-color'>Callback</span> </h2>


                        <form action="" onSubmit={handleSubmit}>
                            <div className="row mb-3">
                                <div className="col-md-6 mb-3 mb-md-0">
                                    <label className="text-gray-600 mr-2 contact-info">Name*</label>
                                    <input type="text"
                                        name="first_name"
                                        ref={firstNameRef}
                                        onMouseEnter={() => setHoveredInput('firstName')}
                                        onMouseLeave={() => setHoveredInput(null)}
                                        onFocus={() => setHoveredInput(null)}
                                        onMouseDown={() => setHoveredInput(null)}
                                        onChange={handleChange}
                                        value={formData.first_name}
                                        className='form-control form-control-underline shadow-none w-full border-b placeholder:text-left text-left contact-info'
                                        placeholder='First Name' />
                                    <Overlay target={firstNameRef.current} show={hoveredInput === 'firstName'} placement="bottom">
                                        {(props) => (
                                            <Tooltip id="firstName-tooltip" {...props}>
                                                Enter your first name
                                            </Tooltip>
                                        )}
                                    </Overlay>

                                    <label className="text-gray-600 mr-2 contact-info mb-3 mb-md-0 mt-3">Email ID*</label>
                                    <input type="email"
                                        name="email"
                                        ref={emailRef}
                                        onMouseEnter={() => setHoveredInput('email')}
                                        onMouseLeave={() => setHoveredInput(null)}
                                        onFocus={() => setHoveredInput(null)}
                                        onMouseDown={() => setHoveredInput(null)}
                                        onChange={handleChange}
                                        value={formData.email}
                                        className='form-control shadow-none form-control-underline contact-info' style={{ marginTop: "10px" }} placeholder='Your Email ID' />
                                    <Overlay target={emailRef.current} show={hoveredInput === 'email'} placement="bottom">
                                        {(props) => (
                                            <Tooltip id="email-tooltip" {...props}>
                                                Enter your email address
                                            </Tooltip>
                                        )}
                                    </Overlay>

                                </div>

                                <div className="col-md-6">
                                    <label className="text-gray-600 mr-2 contact-info">Last Name*</label>
                                    <input type="text"
                                        name="last_name"
                                        ref={lastNameRef}
                                        onMouseEnter={() => setHoveredInput('lastName')}
                                        onMouseLeave={() => setHoveredInput(null)}
                                        onFocus={() => setHoveredInput(null)}
                                        onMouseDown={() => setHoveredInput(null)}
                                        onChange={handleChange}
                                        value={formData.last_name}
                                        className='form-control shadow-none form-control-underline w-full border-b placeholder:text-left text-left contact-info'
                                        placeholder='Last Name' />
                                    <Overlay target={lastNameRef.current} show={hoveredInput === 'lastName'} placement="bottom">
                                        {(props) => (
                                            <Tooltip id="lastName-tooltip" {...props}>
                                                Enter your last name
                                            </Tooltip>
                                        )}
                                    </Overlay>

                                    <div className="col mb-3 mb-md-0 mt-3">
                                        <label className="text-gray-600 shadow-none mr-2 contact-info">Contact No.*</label>
                                        <div className="d-flex form-control form-control-underline contact-info">
                                            <span className="">+91</span>
                                            <input
                                                name="mobile"
                                                ref={numberRef}
                                                type="tel"
                                                className="form-control border-0 form-control-underline p-0 ps-1 mb-2 shadow-none"
                                                placeholder=""
                                                value={formData.mobile}
                                                onChange={handleChange}
                                                onMouseEnter={() => setHoveredInput('number')}
                                                onMouseLeave={() => setHoveredInput(null)}
                                                onFocus={() => setHoveredInput(null)}
                                                onMouseDown={() => setHoveredInput(null)}
                                                maxLength={10}

                                            />
                                            <Overlay target={numberRef.current} show={hoveredInput === 'number'} placement="bottom">
                                                {(props) => (
                                                    <Tooltip id="number-tooltip" {...props}>
                                                        Enter your 10-digit contact number
                                                    </Tooltip>
                                                )}
                                            </Overlay>
                                        </div>


                                    </div>
                                </div>
                                <div className="col mb-3 mb-md-0 mt-3">
                                    <label className="text-gray-600 mr-2 contact-info ">Your Query*</label>

                                    <textarea
                                        name="comments"
                                        ref={queryRef}
                                        onMouseEnter={() => setHoveredInput('query')}
                                        onMouseLeave={() => setHoveredInput(null)}
                                        onFocus={() => setHoveredInput(null)}
                                        onMouseDown={() => setHoveredInput(null)}
                                        onChange={handleChange}
                                        value={formData.comments}
                                        className='form-control shadow-none form-control-underline contact-info ' placeholder='Describe your query here'></textarea>
                                    <Overlay target={queryRef.current} show={hoveredInput === 'query'} placement="bottom">
                                        {(props) => (
                                            <Tooltip id="query-tooltip" {...props}>
                                                Please describe your query
                                            </Tooltip>
                                        )}
                                    </Overlay>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <button type='submit'
                                    style={{ backgroundColor: "#FF9A00" }}
                                    className='btn text-white mt-3 form-submit-btn '>Submit</button>
                            </div>
                            {(message || errors) && (
                                <div className="col-12 mt-3">
                                    <p
                                        className="message-form"
                                        style={{ color: message ? "green" : "red" }}
                                    >
                                        {message || errors}
                                    </p>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Contact